import {getPublicURL} from "../../utils";
import React from 'react';
import {Image} from "semantic-ui-react";
import { Link } from "react-router-dom";

export default class CompanyLogo extends React.Component {
  render() {
    let img = null;
    if(this.props.linkTo){
      img = <Image src={getPublicURL('images/swift_logo.png')} as={Link} to={this.props.linkTo} centered/>;
    } else {
      img = <Image src={getPublicURL('images/swift_logo.png')} centered/>;
    }

    return (img);
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/CompanyLogo/index.js